export const getLang = (url: string) => url.startsWith('/kz/') ? 'kk' : 'ru';
